import React, { useMemo, useState } from 'react';

import ZpFilter from '../../components/zpFilter';
import { CAROUSEL_FILTERS, FILTER_PARAMS } from '../../components/zpFilter/filterUtils';
import CommonService from '../../services/commonService';

import SalaryTable from './child/salaryTable';

const customColumnConfig = (showCompanyColumn) => ({
  ...(showCompanyColumn && {
    company: {
      columnName: 'Company',
      isLink: 'companyIndexedLink',
      isHiddenMobile: false,
      linkUrl: 'companyLink',
      mobileSubtext: 'title',
      pageIndex: 'indexInfoOfCompanyPage',
    },
  }),
  title: {
    columnName: 'Job',
    isHiddenMobile: true,
    linkUrl: 'comboJobTitleLink',
    isLink: 'jobIndexedLink',
    linkTitle: 'jobColLinkTitle',
  },
  location: {
    columnName: 'Location',
    isHiddenMobile: true,
    isLink: 'locationLink',
    linkUrl: 'locationLink',
    linkTitle: 'locationColLinkTitle',
  },
  dateAdded: {
    columnName: 'Date Added',
    isHiddenMobile: true,
  },
  salary: {
    columnName: 'Salary',
    customSortByField: 'salaryValue',
    mobileSubtext: 'dateAdded',
  },
});

const RecentAddSalaries = (props) => {
  const { recentSalaries, jobTitle, title, showCompanyColumn = true, initialLocation = [] } = props;
  const { salaryData } = recentSalaries;

  const _tableSet = useMemo(() => {
    return salaryData.map((row) => {
      return {
        ...row,
        jobColLinkTitle: `${row.normalizedTitle} Jobs`,
        locationColLinkTitle: `${row.normalizedTitle} Salary in ${row.location}`,
      };
    });
  }, [salaryData]);

  const [tableData, setTableData] = useState(_tableSet);

  const preselectedFilterLocation = (() => {
    const { state = '', city = '', stateAbbr = '' } = initialLocation?.[0] || {};

    if (!state && !stateAbbr) return [];

    return [
      {
        value: { city, state },
        displayName: city ? `${city}, ${stateAbbr}` : state,
      },
    ];
  })();

  const handleFilterUpdate = async (_, data) => {
    try {
      if (!data.length) {
        setTableData(_tableSet);
        return;
      }
      const promises = data.map(({ value }) => {
        let payload = {
          title: jobTitle,
        };
        if (value.city) {
          payload = { ...payload, city: value.city, state: value.state };
        } else {
          payload = { ...payload, state: value.state };
        }
        return CommonService.fetchRecentSalaries(payload);
      });

      const response = await Promise.all(promises);

      let newSalaryData = [];

      response.forEach((responseData) => {
        const formattedData = responseData.map((row) => {
          return {
            ...row,
            jobColLinkTitle: `${row.normalizedTitle} Jobs`,
            locationColLinkTitle: `${row.normalizedTitle} Salary in ${row.location}`,
          };
        });
        newSalaryData = newSalaryData.concat(formattedData);
      });

      setTableData(newSalaryData);
    } catch (error) {
      console.error(error);
    }
  };

  const handleFilterClear = () => {
    setTableData(_tableSet);
  };

  const setupFilters = () => ({
    ...CAROUSEL_FILTERS[FILTER_PARAMS.LOCATION],
    options: {
      autoSuggest: true,
      remote: false,
    },
    preselectedItems: preselectedFilterLocation,
  });

  return (
    <div>
      <h2 className="brandonH2 z-mb-48">{title}</h2>

      <div className="mb-4">
        <ZpFilter {...setupFilters()} onApply={handleFilterUpdate} onClear={handleFilterClear} />
      </div>

      <div className="salary-table-section">
        <SalaryTable
          customColumnConfig={customColumnConfig(showCompanyColumn)}
          tableDataSet={tableData}
        />
      </div>
    </div>
  );
};

export default RecentAddSalaries;
